import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class TimeZoneService {
    private countryTimezoneMap: {[key: string]: string} = {
        'UK': 'Europe/London',
        'EU': 'Europe/Paris',
        'US': 'America/New_York',
        'CA': 'America/Toronto',
        'AU': 'Australia/Sydney',
        'NZ': 'Pacific/Auckland',
        'HK': 'Asia/Hong_Kong',
        'AE': 'Asia/Dubai',
    };

    constructor() {
        console.log("TimeZone: " + this.getCurrentTimeZone());
    }

    private getCurrentTimeZone(): string {
        const savedCountry = localStorage.getItem('selectedCountry');
        if (savedCountry && this.countryTimezoneMap[savedCountry]) {
            return this.countryTimezoneMap[savedCountry];
        }
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    public setCountry(code: string): void {
        this.setCountryLocalOnly(code);
        window.location.reload();
    }

    public setCountryLocalOnly(code: string): void {
        if (code) {
            localStorage.setItem('selectedCountry', code);
        } else {
            localStorage.removeItem('selectedCountry');
        }
    }

    public getSelectedCountry(): string {
        return localStorage.getItem('selectedCountry') || '';
    }

    // Resolves the customer's country for tax purposes the same way pricing does
    // (falling back to browser timezone auto-detection), instead of only the
    // explicitly-selected flag — an empty selectedCountry must not default to UK tax.
    public getResolvedCountry(): string {
        if (this.checkUSATimeZone()) return 'US';
        if (this.checkAustraliaTimeZone()) return 'AU';
        if (this.checkAucklandTimeZone()) return 'NZ';
        if (this.checkHongKongTimeZone()) return 'HK';
        if (this.checkEUTimeZone()) return 'EU';
        if (this.checkCanadaTimeZone()) return 'CA';
        if (this.checkUAETimeZone()) return 'AE';
        return 'UK';
    }

    public checkDefaultTimeZone(): boolean
    {
        // This one is the default configuration
        if(this.checkEuropeTimezone()) return true;
        //
        if(
            this.checkUSATimeZone() ||
            this.checkAustraliaTimeZone() ||
            this.checkAucklandTimeZone() ||
            this.checkHongKongTimeZone() ||
            this.checkEUTimeZone() ||
            this.checkCanadaTimeZone() ||
            this.checkUAETimeZone()
        ) {
            return false;
        }

        return true;
    }

    // Default areas
    // ======================================================================
    public checkEuropeTimezone(): boolean
    {
        return this.getCurrentTimeZone().includes('Europe');
    }

    // Specific timezones areas
    // ======================================================================
    public checkUAETimeZone(): boolean
    {
        var timezonesUAE = [
            'Asia/Dubai'
        ];

        return timezonesUAE.includes(this.getCurrentTimeZone());
    }

    public checkCanadaTimeZone(): boolean
    {
        var timezonesCanada = [
            'America/Vancouver',
            'America/Whitehorse',
            'America/Edmonton',
            'America/Regina',
            'America/Winnipeg',
            'America/Toronto',
            'America/Blanc-Sablon',
            'America/Halifax',
            'America/St_Johns',
        ];

        return timezonesCanada.includes(this.getCurrentTimeZone());
    }

    public checkEUTimeZone(): boolean
    {
        return localStorage.getItem('selectedCountry') === 'EU';
    }

    public checkHongKongTimeZone(): boolean
    {
        var timezonesHongKong = [
            'Asia/Hong_Kong'
        ];

        return timezonesHongKong.includes(this.getCurrentTimeZone());
    }

    public checkAucklandTimeZone(): boolean
    {
        var timezonesAuckland = [
            'Pacific/Auckland'
        ];

        return timezonesAuckland.includes(this.getCurrentTimeZone());
    }

    public checkAustraliaTimeZone(): boolean
    {
        var timezonesAustralia = [
            'Australia/Lord_Howe',
            'Australia/Hobart',
            'Australia/Currie',
            'Australia/Melbourne',
            'Australia/Sydney',
            'Australia/Broken_Hill',
            'Australia/Brisbane',
            'Australia/Lindeman',
            'Australia/Adelaide',
            'Australia/Darwin',
            'Australia/Perth',
            'Australia/Eucla',
        ];

        return timezonesAustralia.includes(this.getCurrentTimeZone());
    }

    public checkUSATimeZone(): boolean
    {
        var timezonesNorthAmerica = [
            'America/Resolute',
            'America/New_York',
            'America/Detroit',
            'America/Kentucky/Louisville',
            'America/Kentucky/Monticello',
            'America/Indiana/Indianapolis',
            'America/Indiana/Vincennes',
            'America/Indiana/Winamac',
            'America/Indiana/Marengo',
            'America/Indiana/Petersburg',
            'America/Indiana/Vevay',
            'America/Chicago',
            'America/Indiana/Tell_City',
            'America/Indiana/Knox',
            'America/Menominee',
            'America/North_Dakota/Center',
            'America/North_Dakota/New_Salem',
            'America/North_Dakota/Beulah',
            'America/Denver',
            'America/Boise',
            'America/Phoenix',
            'America/Los_Angeles',
            'America/Anchorage',
            'America/Juneau',
            'America/Sitka',
            'America/Metlakatla',
            'America/Yakutat',
            'America/Nome',
            'America/Adak',
        ];

        return timezonesNorthAmerica.includes(this.getCurrentTimeZone());
    }
}
